module.exports = "pegasus/assets/themelp1/large/50.png";